











































import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { SfButton, SfInput, SfLoader, } from '@storefront-ui/vue';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { email, required } from 'vee-validate/dist/rules';
import { ForgotPasswordFormFields } from './types';

extend('email', {
  ...email,
  message: 'Invalid email',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

export default defineComponent({
  components: {
    SfInput,
    SfButton,
    SfLoader,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    form: {
      type: Object as PropType<ForgotPasswordFormFields>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showRecaptcha: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const formCopy = ref<ForgotPasswordFormFields>();
    watch(() => props.form, (newForm) => {
      formCopy.value = { ...newForm };
    }, { immediate: true, deep: true });
    return { formCopy };
  },
});
